export enum RequestType {
  Withdrawal = 1,
  Refund = 2,
}